<i18n>
en:
  title: "Store information"
  stepper:
    basic: "Basic"
    shop: "Store"
    map: "Map"
    station: "Station"
    sales: "Business day"
    bank: "Bank"
    terms: "Terms"
  hintKana: "Japanese double-byte katakana"
  mail:
    label: "E-mail Address (read only)"
  password:
    label:
      new: "New password"
      edit: "New password (only when changing)"
    hint: "8 or more alphanumeric symbols"
    confirm:
      label: "Re-enter password"
      error: "Passwords do not match"
  name:
    label: "Representative's name"
  tel:
    label: "Phone"
    hint: "Only numbers without hyphens"
  fax:
    label: "Fax number"
    hint: "Only numbers without hyphens"
  url:
    label: "URL"
  shopName:
    label:
      jp: "Store name (Japanese)"
      kana: "Store name (Katakana)"
  zip:
    label: "Postal code"
    hint: "Only numbers without hyphens"
  prefecture:
    label: "Region"
  address1:
    label:
      jp: "City (Japanese)"
      kana: "City (Katakana)"
  address2:
    label:
      jp: "Address line (Japanese)"
      kana: "Address line (Katakana)"
  address3:
    label: "Block number"
  address4:
    label:
      jp: "Apartment (Japanese)"
      kana: "Apartment (Katakana)"
  address5:
    label: "Room number"
  hours:
    label: "Business hours"
    alltime:
      label: "Open 24 hours"
    openHour:
      label: "Opening hours"
    openMinute:
      label: "Minutes"
    closeHour:
      label: "Closing hours"
    closeMinute:
      label: "Minutes"
  reserveToday:
    ok:
      label: "Same day reservation: OK"
    ng:
      label: "Same day reservation: NG"
  luggage:
    label: "Baggage allowance"
  industry:
    label: "Industry"
  equipment:
    label: "Equipment"
  holidays:
    label: "Regular holiday"
    weekNum:
      label: "Week"
      list:
        every: "Every"
        1st: "1st"
        2nd: "2nd"
        3rd: "3rd"
        4th: "4th"
        5th: "5th"

    dayOfWeek:
      label: "Day of the week"
      list:
        sun: "Sunday"
        mon: "Monday"
        tue: "Tuesday"
        wed: "Wednesday"
        thu: "Thursday"
        fri: "Friday"
        sat: "Saturday"
  station:
    label: "Nearest station"
    walk:
      label: "Time required (walk)"
      suffix: "minutes"
    none: "There is no station nearby<br>Proceed with store registration without registering for the nearest station"
  bankName:
    label: "Bank name"
  branchName:
    label: "Branch name"
  accountKind:
    label: "Deposit item"
    list:
      savings: "Savings account"
      checking: "Checking account"
  accountNumber:
    label: "Account number"

  tos:
    title: "Terms of Service"
    label: "I agree that Terms of Service"

  back: "Back"
  next: "Next"
  submit: "Regist"
  error:
    IUM002: "Unable to register due to expiration.<br>Please start over."
    IUM003: "URL is incorrect.<br>Please start over."
    err: "Regist failed."

ja:
  title: "店舗情報"
  stepper:
    basic: "基本情報"
    shop: "店舗情報"
    map: "地図"
    station: "最寄り駅"
    sales: "営業情報"
    bank: "銀行口座"
    terms: "規約"
  hintKana: "全角カタカナで入力してください"
  mail:
    label: "メールアドレス（変更不可）"
  password:
    label:
      new: "パスワード"
      edit: "パスワード（変更時のみ入力）"
    hint: "半角英数字を組み合わせた8桁以上で入力してください"
    confirm:
      label: "パスワード（確認）"
      error: "パスワードが一致しません"
  name:
    label: "代表者名"
  tel:
    label: "電話番号"
    hint: "ハイフンなしの数字のみで入力してください"
  fax:
    label: "FAX番号"
    hint: "ハイフンなしの数字のみで入力してください"
  shopName:
    label:
      jp: "店舗名"
      kana: "店舗名（カナ）"
  zip:
    label: "郵便番号"
    hint: "ハイフンなしの数字のみで入力してください"
  prefecture:
    label: "都道府県"
  address1:
    label:
      jp: "市区町村（日本）"
      kana: "市区町村（カナ）"
  address2:
    label:
      jp: "町名（日本）"
      kana: "町名（カナ）"
  address3:
    label: "番地"
  address4:
    label:
      jp: "建物名（日本）"
      kana: "建物名（カナ）"
  address5:
    label: "部屋番号"
  hours:
    label: "営業時間"
    alltime:
      label: "２４時間営業"
    openHour:
      label: "開店時間（時）"
    openMinute:
      label: "分"
    closeHour:
      label: "閉店時間（時）"
    closeMinute:
      label: "分"
  reserveToday:
    ok:
      label: "当日予約： OK"
    ng:
      label: "当日予約： NG"
  luggage:
    label: "荷物許容点数"
  industry:
    label: "業種"
  equipment:
    label: "設備"
  holidays:
    label: "定休日"
    weekNum:
      label: "週"
      list:
        every: "毎週"
        1st: "第１"
        2nd: "第２"
        3rd: "第３"
        4th: "第４"
        5th: "第５"
    dayOfWeek:
      label: "曜日"
      list:
        sun: "日曜日"
        mon: "月曜日"
        tue: "火曜日"
        wed: "水曜日"
        thu: "木曜日"
        fri: "金曜日"
        sat: "土曜日"
  station:
    label: "最寄り駅"
    walk:
      label: "所要時間（徒歩）"
      suffix: "分"
    none: "近くに駅はありません<br>最寄り駅の登録無しで店舗の登録を進めます"
  bankName:
    label: "銀行名"
  branchName:
    label: "支店名"
  accountKind:
    label: "預金種目"
    list:
      savings: "普通口座"
      checking: "当座口座"
  accountNumber:
    label: "口座番号"

  tos:
    title: "利用規約"
    label: "利用規約に同意します"

  back: "戻る"
  next: "次へ"
  submit: "登録する"
  error:
    IUM002: "有効期限切れのためユーザー登録できません。<br>最初からやり直してください。"
    IUM003: "URLが正しくありません。<br>最初からやり直してください。"
    err: "登録に失敗しました。"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- タイトル
      v-row(v-if="!newEntry")
        v-col(cols="12" align="center")
          h2|{{$t('title')}}
        v-col.pt-0.pb-4(cols="12" align="center")
          v-img(src="@/assets/images/title-underline.png" width="227px" height="24px")

      //- 読込中
      template(v-if="isLoading")
        v-row
          v-col.my-12.pa-12(cols="12")
            v-progress-linear(indeterminate)

      //- 認証失敗
      template(v-else-if="!certify")
        v-row
          v-col.my-12.py-12(cols="12" align="center")
            v-alert.d-inline-block(dense outlined type="error")
              div(v-html="errMsg")

      //- 入力フォーム
      template(v-else)
        v-stepper.transparent.none-shadow(alt-labels v-model="step")
          v-stepper-header.px-md-12.px-lg-12.px-xl-12.none-shadow
            v-stepper-step(:step="1" :complete="step > 1")|{{$t('stepper.basic')}}
            v-divider
            v-stepper-step(:step="2" :complete="step > 2")|{{$t('stepper.shop')}}
            v-divider
            v-stepper-step(:step="3" :complete="step > 3")|{{$t('stepper.map')}}
            v-divider
            v-stepper-step(:step="4" :complete="step > 4")|{{$t('stepper.station')}}
            v-divider
            v-stepper-step(:step="5" :complete="step > 5")|{{$t('stepper.sales')}}
            v-divider
            v-stepper-step(:step="6" :complete="step > 6")|{{$t('stepper.bank')}}
            v-divider
            v-stepper-step(:step="7" :complete="step > 7")|{{$t('stepper.terms')}}

          v-stepper-items
            //- STEP1
            v-stepper-content.px-0(:step="1")
              v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid.step1")
                v-row(v-if="forms.mail")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field(prepend-icon="fa-envelope" :label="$t('mail.label')" maxlength="255" v-model="forms.mail" readonly)

                v-row(v-if="newEntry")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(type="password" prepend-icon="fa-key" :label="$t('password.label.new')" persistent-hint :hint="$t('password.hint')" :rules="v($t('password.label.new'), ['required', 'password'])" maxlength="32" v-model="forms.password")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0.required(type="password" :label="$t('password.confirm.label')" :rules="v($t('password.confirm.label'), ['required'])" :error="validPassword.error" :error-messages="validPassword.message" maxlength="32" v-model="forms.passwordConfirm")
                v-row(v-else)
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field(type="password" prepend-icon="fa-key" :label="$t('password.label.edit')" persistent-hint :hint="$t('password.hint')" :rules="v($t('password.label.edit'), ['password'])" maxlength="32" v-model="forms.password")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0(type="password" :label="$t('password.confirm.label')" :error="validPassword.error" :error-messages="validPassword.message" maxlength="32" v-model="forms.passwordConfirm")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-signature" :label="$t('name.label')" :rules="v($t('name.label'), ['required'])" maxlength="50" v-model="forms.name")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(type="tel" prepend-icon="fa-phone" :label="$t('tel.label')" persistent-hint :hint="$t('tel.hint')" :rules="v($t('tel.label'), ['required', 'number'])" maxlength="20" v-model="forms.tel")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field(type="tel" prepend-icon="fa-fax" :label="$t('fax.label')" persistent-hint :hint="$t('fax.hint')" :rules="v($t('fax.label'), ['number'])" maxlength="20" v-model="forms.fax")

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="nextStep(1)" :disabled="!valid.step1")|{{$t('next')}}

            //- STEP2
            v-stepper-content.px-0(:step="2")
              v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid.step2")
                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-store" :label="$t('shopName.label.jp')" :rules="v($t('shopName.label.jp'), ['required'])" maxlength="50" v-model="forms.shopNameJp")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0.required(:label="$t('shopName.label.kana')" persistent-hint :hint="$t('hintKana')" :rules="v($t('shopName.label.kana'), ['required', 'kana'])" maxlength="50" v-model="forms.shopNameKana")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-tenge" :label="$t('zip.label')" persistent-hint :hint="$t('zip.hint')" :rules="v($t('zip.label'), ['required', 'number'])" maxlength="7" v-model="forms.zip")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-select.required(prepend-icon="fa-map-marked" :label="$t('prefecture.label')" :items="$store.getters.area_list" item-text="areaName" return-object :rules="v($t('prefecture.label'), ['required'])" v-model="forms.prefecture" :loading="$store.getters.area_list.length === 0")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-map-marked-alt" :label="$t('address1.label.jp')" :rules="v($t('address1.label.jp'), ['required'])" maxlength="50" v-model="forms.address1Jp")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0.required(:label="$t('address1.label.kana')" persistent-hint :hint="$t('hintKana')" :rules="v($t('address1.label.kana'), ['required', 'kana'])" maxlength="50" v-model="forms.address1Kana")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-city" :label="$t('address2.label.jp')" :rules="v($t('address2.label.jp'), ['required'])" maxlength="50" v-model="forms.address2Jp")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0.required(:label="$t('address2.label.kana')" persistent-hint :hint="$t('hintKana')" :rules="v($t('address2.label.kana'), ['required', 'kana'])" maxlength="50" v-model="forms.address2Kana")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-map-signs" :label="$t('address3.label')" :rules="v($t('address3.label'), ['required', 'numberHyphen'])" maxlength="50" v-model="forms.address3Jp")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field(prepend-icon="fa-building" :label="$t('address4.label.jp')" maxlength="50" v-model="forms.address4Jp")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0(:label="$t('address4.label.kana')" persistent-hint :hint="$t('hintKana')" :rules="v($t('address4.label.kana'), ['kana'])" maxlength="50" v-model="forms.address4Kana")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field(prepend-icon="fa-id-badge" :label="$t('address5.label')" :rules="v($t('address5.label'), ['number'])" maxlength="50" v-model="forms.address5Jp")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field(prepend-icon="fa-link" :label="$t('url.label')" :rules="v($t('url.label'), ['url'])" maxlength="300" v-model="forms.url")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-luggage-cart" :label="$t('luggage.label')" :rules="v($t('luggage.label'), ['required', 'number'])" maxlength="4" v-model="forms.luggage")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-select.required(prepend-icon="fa-icons" :label="$t('industry.label')" :items="industryList" item-value="code" item-text="name" :rules="v($t('industry.label'), ['required'])" v-model="forms.industry")

                v-row
                  v-col(cols="12" align-self="center")
                    v-icon|fa-shapes
                    span.ml-3|{{$t('equipment.label')}}
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-checkbox.ml-8.mt-0(v-for="(item, index) in equipmentList" :key="`equipment-${index}`" hide-details :label="item.name" :true-value="item.code" :false-value="null" v-model="forms.equipments[index]")

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="nextStep(1)" :disabled="!valid.step2")|{{$t('next')}}

            //- STEP3
            v-stepper-content.px-0(:step="3")
              v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false")
                v-row
                  v-col(cols="12")
                    div.map-col
                      GoogleMap.d-flex.map-col-map(:address="addressJp" :location="initLocation" :zoom="17" :marker="[]" @mapMove="mapMove" @load="mapLoad")
                      v-img.pink--text.map-col-center-pin(src="@/assets/images/map-marker.png")

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="nextStep(1); loadStation();")|{{$t('next')}}

            //- STEP4
            v-stepper-content.px-0(:step="4")
              template(v-if="isStationLoading")
                v-row
                  v-col.my-12.pa-12(cols="12")
                    v-progress-linear(indeterminate)

              template(v-else-if="stationList && stationList.length > 0")
                v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid.step4")
                    v-row
                      v-col(cols="12" align-self="center")
                        v-icon|fa-subway
                        span.ml-3|{{$t('station.label')}}

                    v-row(v-for="(item, index) in forms.stations" :key="`station-${index}`")
                      v-col(cols="12" sm="6" md="4" xl="2")
                        v-select.ml-4.required(dense :prepend-icon="diceIcon(index)" :label="$t('station.label')" :items="stationList" item-value="code" item-text="name" :rules="v($t('station.label'), ['required'])" v-model="item.stationId")
                      v-col(cols="12" sm="6" md="4" xl="2")
                        v-text-field.ml-12.ml-md-0.required.required(dense :label="$t('station.walk.label')" :suffix="$t('station.walk.suffix')" :rules="v($t('station.walk.label'), ['required', 'number'])" maxlength="3" v-model="item.walkMinute")

                    v-row
                      v-col.ml-8(cols="12" align-self="center")
                        v-btn.white--text(fab small color="primary" elevation="1" @click="removeStations" :disabled="forms.stations.length <= 1")
                          v-icon|mdi-minus
                        v-btn.ml-2.white--text(fab small color="primary" elevation="1" @click="addStations" :disabled="forms.stations.length >= 4")
                          v-icon|mdi-plus

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="nextStep(1)" :disabled="!valid.step4")|{{$t('next')}}

              template(v-else)
                v-row
                  v-col.my-12.py-12(cols="12" align="center")
                    v-alert.d-inline-block(dense outlined type="warning")
                      div(v-html="$t('station.none')")

                  //- 次へ
                  v-row.mt-12(justify="center")
                    v-col(cols="12" sm="4" md="3" xl="2")
                      v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                    v-col(cols="12" sm="4" md="3" xl="2")
                      v-btn(x-large block type="submit" color="primary" @click="nextStep(1)")|{{$t('next')}}

            //- STEP5
            v-stepper-content.px-0(:step="5")
              v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid.step5")
                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-switch(hide-details prepend-icon="fa-clipboard-check" color="primary" :label="$t(forms.reserveToday ? 'reserveToday.ok.label' : 'reserveToday.ng.label')" v-model="forms.reserveToday")

                v-row.mt-7
                  v-col(cols="12" align-self="center")
                    v-icon|fa-door-open
                    span.ml-3|{{$t('hours.label')}}
                    v-checkbox.mt-0.ml-6.d-inline-flex(hide-details color="primary" :label="$t('hours.alltime.label')" v-model="forms.alltime")

                v-row(v-for="(item, index) in forms.hours" :key="`hour-${index}`")
                  v-col(cols="12" sm="6" md="4" xl="2")
                    v-select.ml-4(dense :class="{required: !forms.alltime}" :prepend-icon="diceIcon(index)" :label="$t('hours.openHour.label')" :items="hours" :rules="forms.alltime ? [] : v($t('hours.openHour.label'), ['required'])" v-model="item.openHour" :disabled="forms.alltime")
                  v-col(cols="12" sm="4" md="2" xl="2")
                    v-select.ml-12.ml-sm-0(dense :class="{required: !forms.alltime}" :label="$t('hours.openMinute.label')" :items="minutes" :rules="forms.alltime ? [] : v($t('hours.openMinute.label'), ['required'])" v-model="item.openMinute" :disabled="forms.alltime")
                  v-col(cols="12" sm="6" md="4" xl="2")
                    v-select.ml-12.ml-md-0(dense :class="{required: !forms.alltime}" :label="$t('hours.closeHour.label')" :items="hours" :rules="forms.alltime ? [] : v($t('hours.closeHour.label'), ['required'])" v-model="item.closeHour" :disabled="forms.alltime")
                  v-col(cols="12" sm="4" md="2" xl="2")
                    v-select.ml-12.ml-sm-0(dense :class="{required: !forms.alltime}" :label="$t('hours.closeMinute.label')" :items="minutes" :rules="forms.alltime ? [] : v($t('hours.closeMinute.label'), ['required'])" v-model="item.closeMinute" :disabled="forms.alltime")

                v-row
                  v-col.ml-8(cols="12" align-self="center")
                    v-btn.white--text(fab small color="primary" elevation="1" @click="removeHours" :disabled="forms.alltime || forms.hours.length <= 1")
                      v-icon|mdi-minus
                    v-btn.ml-2.white--text(fab small color="primary" elevation="1" @click="addHours" :disabled="forms.alltime || forms.hours.length >= 4")
                      v-icon|mdi-plus

                v-row.mt-7
                  v-col(cols="12" align-self="center")
                    v-icon|fa-calendar-times
                    span.ml-3|{{$t('holidays.label')}}

                v-row(v-for="(item, index) in forms.holidays" :key="`holiday-${index}`")
                  v-col(cols="12" sm="6" md="4" xl="2")
                    v-select.ml-4.required(dense :prepend-icon="diceIcon(index)" :label="$t('holidays.weekNum.label')" :items="weekNumList" :rules="v($t('holidays.weekNum.label'), ['required'])" v-model="item.weekNum")
                  v-col(cols="12" sm="4" md="2" xl="2")
                    v-select.ml-12.ml-sm-0.required(dense :label="$t('holidays.dayOfWeek.label')" :items="dayOfWeekList" :rules="v($t('holidays.dayOfWeek.label'), ['required'])" v-model="item.dayOfWeek")

                v-row
                  v-col.ml-8(cols="12" align-self="center")
                    v-btn.white--text(fab small color="primary" elevation="1" @click="removeHolidays" :disabled="forms.holidays.length <= 1")
                      v-icon|mdi-minus
                    v-btn.ml-2.white--text(fab small color="primary" elevation="1" @click="addHolidays" :disabled="forms.holidays.length >= 10")
                      v-icon|mdi-plus

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="nextStep(1)" :disabled="!valid.step5")|{{$t('next')}}

            //- STEP6
            v-stepper-content.px-0(:step="6")
              v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid.step6")
                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.required(prepend-icon="fa-university" :label="$t('bankName.label')" :rules="v($t('bankName.label'), ['required'])" maxlength="50" v-model="forms.bankName")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0.required(:label="$t('branchName.label')" :rules="v($t('branchName.label'), ['required'])" maxlength="50" v-model="forms.branchName")

                v-row
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-select.required(prepend-icon="fa-money-check" :label="$t('accountKind.label')" :items="accountKindList" :rules="v($t('accountKind.label'), ['required'])" v-model="forms.accountKind")
                  v-col(cols="12" sm="10" md="6" xl="4")
                    v-text-field.ml-8.ml-md-0.required(:label="$t('accountNumber.label')" :rules="v($t('accountNumber.label'), ['required', 'number'])" maxlength="7" v-model="forms.accountNumber")

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="nextStep(1)" :disabled="!valid.step6")|{{$t('next')}}

            //- STEP7
            v-stepper-content.px-0(:step="7")
              v-form.px-md-8.px-lg-10.px-xl-12(onsubmit="return false" v-model="valid.step7")
                v-row
                  v-col(cols="12" align="center")
                    section
                      h1|{{$t('tos.title')}}
                      div.tos-box
                        TermsOfService

                      v-checkbox.d-inline-block(color="success" :label="$t('tos.label')" :rules="v($t('tos.title'), ['required'])" v-model="forms.agree")

                //- 次へ
                v-row.mt-12(justify="center")
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block color="secondary" @click="nextStep(-1)")|{{$t('back')}}
                  v-col(cols="12" sm="4" md="3" xl="2")
                    v-btn(x-large block type="submit" color="primary" @click="regist" :loading="isSubmit" :disabled="!valid.step7")|{{$t('submit')}}

                //- エラーメッセージ
                v-row(v-if="errMsg")
                  v-col(cols="12" align="center")
                    v-alert.d-inline-block(dense outlined type="error")
                      div(v-html="errMsg")
</template>

<script>
import GoogleMap from '@/components/GoogleMap/GoogleMap'
import TermsOfService from '@/components/documents/TermsOfService'

export default {
  components: {
    GoogleMap,
    TermsOfService
  },
  data () {
    return {
      // 新規登録（false: 編集）
      newEntry: true,
      // 時間一覧
      hours: null,
      // 分一覧
      minutes: null,
      // 業種一覧
      industryList: null,
      // 設備一覧
      equipmentList: null,
      // 駅一覧
      stationList: null,
      // 入力フォーム
      forms: {
        mail: null,
        password: null,
        passwordConfirm: null,
        name: null,
        tel: null,
        fax: null,
        shopNameJp: null,
        shopNameKana: null,
        zip: null,
        prefecture: null,
        address1Jp: null,
        address1Kana: null,
        address2Jp: null,
        address2Kana: null,
        address3Jp: null,
        address4Jp: null,
        address4Kana: null,
        address5Jp: null,
        url: null,
        luggage: null,
        industry: null,
        equipments: [],
        stations: [],
        reserveToday: null,
        alltime: false,
        hours: [],
        holidays: [],
        bankName: null,
        branchName: null,
        accountKind: null,
        accountNumber: null,
        agree: null,
        mapLatitude: null,
        mapLongitude: null
      },
      // 入力バリデーション
      valid: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
        step7: false
      },
      // ステップ
      step: 1,
      // 初期表示の位置情報
      initLocation: null,
      // 送信中
      isSubmit: false,
      // 読込中
      isLoading: true,
      // 駅の読込中
      isStationLoading: true,
      // 認証
      certify: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  created () {
    this.hours = [...Array(24).keys()].map(i => {
      return {
        value: i,
        text: this.utils.string.padding(i, 2)}
    })
    this.minutes = [...Array(6).keys()].map(i => {
      const value = i * 10
      return {
        value,
        text: this.utils.string.padding(value, 2)}
    })
    this.addStations()
    this.addHours()
    this.addHolidays()

    this.loadMaster()
      .then(() => {
        if (this.newEntry) {
          this.loadFirst()
        } else {
          this.loadShop()
        }
      })
  },
  computed: {
    /**
     * 住所
     */
    addressJp () {
      if (!this.forms.prefecture) {
        return null
      }
      return (this.forms.prefecture.areaName || '') +
        (this.forms.address1Jp || '') +
        (this.forms.address2Jp || '') +
        (this.forms.address3Jp || '') +
        (this.forms.address4Jp || '') +
        (this.forms.address5Jp || '')
    },
    /**
     * パスワードの検証
     */
    validPassword () {
      if (!this.forms.password || this.forms.password === this.forms.passwordConfirm) {
        return {
          error: false,
          message: null
        }
      } else {
        return {
          error: true,
          message: this.$t('password.confirm.error')
        }
      }
    },
    /**
     * 銀行種別一覧
     */
    accountKindList () {
      return [
        { value: 1, text: this.$t('accountKind.list.savings') },
        { value: 2, text: this.$t('accountKind.list.checking') }
      ]
    },
    /**
     * 週数一覧
     */
    weekNumList () {
      return [
        { value: 0, text: this.$t('holidays.weekNum.list.every') },
        { value: 1, text: this.$t('holidays.weekNum.list.1st') },
        { value: 2, text: this.$t('holidays.weekNum.list.2nd') },
        { value: 3, text: this.$t('holidays.weekNum.list.3rd') },
        { value: 4, text: this.$t('holidays.weekNum.list.4th') },
        { value: 5, text: this.$t('holidays.weekNum.list.5th') }
      ]
    },
    /**
     * 曜日一覧
     */
    dayOfWeekList () {
      return [
        { value: 1, text: this.$t('holidays.dayOfWeek.list.sun') },
        { value: 2, text: this.$t('holidays.dayOfWeek.list.mon') },
        { value: 3, text: this.$t('holidays.dayOfWeek.list.tue') },
        { value: 4, text: this.$t('holidays.dayOfWeek.list.wed') },
        { value: 5, text: this.$t('holidays.dayOfWeek.list.thu') },
        { value: 6, text: this.$t('holidays.dayOfWeek.list.fri') },
        { value: 7, text: this.$t('holidays.dayOfWeek.list.sat') }
      ]
    }
  },
  methods: {
    /**
     * マスターを読込
     */
    loadMaster () {
      return new Promise((resolve, reject) => {
        this.api.master({})
          .then(response => {
            this.industryList = response.data.industryList
            this.equipmentList = response.data.shopEnvList
            this.forms.equipments = Array.from(this.equipmentList, item => null)
            resolve()
          })
          .catch(response => {
            this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
            reject(this.errMsg)
          })
      })
    },
    /**
     * 店舗情報を読込
     */
    loadShop () {
      this.api.shopUser({})
        .then(response => {
          this.forms.shopId = response.data.shopId
          this.forms.name = response.data.managerName
          this.forms.tel = response.data.tel
          this.forms.fax = response.data.fax
          this.forms.shopNameJp = response.data.shopNameJp
          this.forms.shopNameKana = response.data.shopNameKana
          this.forms.zip = response.data.zipCode
          this.forms.prefecture = this.$store.getters.area({areaId: response.data.prefectureId})
          this.forms.address1Jp = response.data.address1Jp
          this.forms.address1Kana = response.data.address1Kana
          this.forms.address2Jp = response.data.address2Jp
          this.forms.address2Kana = response.data.address2Kana
          this.forms.address3Jp = response.data.address3Jp
          this.forms.address4Jp = response.data.address4Jp
          this.forms.address4Kana = response.data.address4Kana
          this.forms.address5Jp = response.data.address5Jp
          this.forms.url = response.data.url
          this.forms.luggage = response.data.capa
          this.forms.industry = response.data.industryId
          this.forms.equipments = Array.from(this.equipmentList, item => response.data.shopEnvIdList.indexOf(item.code) >= 0 ? item.code : null)
          this.forms.stations = response.data.shopStationList || []
          this.forms.reserveToday = (response.data.reserveToday === 1)
          this.forms.alltime = (response.data.alltimeFlg === 1)
          this.forms.hours = Object.entries(response.data.shopOpentimeList).map(([key, item]) => {
            const startTime = this.utils.cast.time(item.startTime)
            const endTime = this.utils.cast.time(item.endTime)
            return {
              openHour: startTime.getHours(),
              openMinute: startTime.getMinutes(),
              closeHour: endTime.getHours(),
              closeMinute: endTime.getMinutes()
            }
          })
          this.forms.holidays = response.data.shopHolidayWeekList || []
          this.forms.bankName = response.data.accountBankName
          this.forms.branchName = response.data.accountBranchName
          this.forms.accountKind = response.data.accountKind
          this.forms.accountNumber = response.data.accountNumber
          this.forms.mapLatitude = response.data.mapLatitude
          this.forms.mapLongitude = response.data.mapLongitude
          this.certify = true
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /**
     * 新規登録時の情報を読込（HASHから登録情報を取得）
     */
    loadFirst () {
      this.isLoading = true

      this.api.userHashConfirm({
        userKind: 1,
        hash: this.$route.params.hash
      })
        .then(response => {
          this.forms.mail = response.data.mailAddress
          this.certify = true
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /**
     * 駅を読込
     */
    loadStation () {
      this.isStationLoading = true

      this.api.stationList({
        mapLatitude: this.forms.mapLatitude,
        mapLongitude: this.forms.mapLongitude
      })
        .then(response => {
          this.stationList = response.data.stationList
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isStationLoading = false
        })
    },
    /**
     * 駅を追加
     */
    addStations () {
      if (this.forms.stations.length >= 10) {
        return
      }
      this.forms.stations.push([
        {
          stationId: null,
          walkMinute: null
        }
      ])
    },
    /**
     * 駅を削除
     */
    removeStations () {
      if (this.forms.stations.length <= 1) {
        return
      }
      this.forms.stations.pop()
    },
    /**
     * 時間を追加
     */
    addHours () {
      if (this.forms.hours.length >= 5) {
        return
      }
      this.forms.hours.push([
        {
          openHour: null,
          openMinute: null,
          closeHour: null,
          closeMinute: null
        }
      ])
    },
    /**
     * 時間を削除
     */
    removeHours () {
      if (this.forms.hours.length <= 1) {
        return
      }
      this.forms.hours.pop()
    },
    /**
     * 定休日を追加
     */
    addHolidays () {
      if (this.forms.holidays.length >= 10) {
        return
      }
      this.forms.holidays.push([
        {
          weekNum: null,
          dayOfWeek: null
        }
      ])
    },
    /**
     * 定休日を削除
     */
    removeHolidays () {
      if (this.forms.holidays.length <= 1) {
        return
      }
      this.forms.holidays.pop()
    },
    /**
     * 次のSTEPに移動
     */
    nextStep (value) {
      this.step += value
      window.scrollTo(0, 0)
    },
    /**
     * 登録
     */
    regist () {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.errMsg = null

      this.api.shopUserRegist({
        hash: this.$route.params.hash || '',
        shopId: this.newEntry ? null : this.forms.shopId,
        mailAddress: this.forms.mail,
        password: this.forms.password,
        managerName: this.forms.name,
        tel: this.forms.tel,
        fax: this.forms.fax,
        shopNameJp: this.forms.shopNameJp,
        shopNameKana: this.forms.shopNameKana,
        zipCode: this.forms.zip,
        prefectureId: this.forms.prefecture.areaId,
        address1Jp: this.forms.address1Jp,
        address1Kana: this.forms.address1Kana,
        address2Jp: this.forms.address2Jp,
        address2Kana: this.forms.address2Kana,
        address3Jp: this.forms.address3Jp,
        address4Jp: this.forms.address4Jp,
        address4Kana: this.forms.address4Kana,
        address5Jp: this.forms.address5Jp,
        url: this.forms.url,
        capa: this.forms.luggage,
        industryId: this.forms.industry,
        shopEnvId: this.forms.equipments.filter(value => value !== null).join(','),
        stationId: Array.from(this.forms.stations, item => item.stationId).join(','),
        walkMinute: Array.from(this.forms.stations, item => item.walkMinute).join(','),
        reserveToday: this.forms.reserveToday ? 1 : 0,
        alltimeFlg: this.forms.alltime ? 1 : 0,
        startTime: Array.from(this.forms.hours, item => this.utils.cast.timeString(item.openHour, item.openMinute)).join(','),
        endTime: Array.from(this.forms.hours, item => this.utils.cast.timeString(item.closeHour, item.closeMinute)).join(','),
        weekNum: Array.from(this.forms.holidays, item => item.weekNum).join(','),
        dayOfWeek: Array.from(this.forms.holidays, item => item.dayOfWeek).join(','),
        accountBankName: this.forms.bankName,
        accountBranchName: this.forms.branchName,
        accountKind: this.forms.accountKind,
        accountNumber: this.forms.accountNumber,
        mapLatitude: this.forms.mapLatitude,
        mapLongitude: this.forms.mapLongitude
      })
        .then(response => {
          if (this.newEntry) {
            this.$router.push({name: 'EntryComplete', params: {newEntry: false, kind: '1'}})
          } else {
            this.$router.push({name: 'ShopComplete'})
          }
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    },
    /**
     * ダイスアイコン取得
     */
    diceIcon (index) {
      switch (index) {
        case 0:
          return 'fa-dice-one'
        case 1:
          return 'fa-dice-two'
        case 2:
          return 'fa-dice-three'
        case 3:
          return 'fa-dice-four'
        case 4:
          return 'fa-dice-five'
        case 5:
          return 'fa-dice-six'
        default:
          return 'fa-dice'
      }
    },
    /**
     * 地図の移動
     */
    mapMove (value) {
      this.forms.mapLatitude = value.lat()
      this.forms.mapLongitude = value.lng()
    },
    /**
     * 地図の読込完了
     */
    mapLoad (value) {
      // TODO そもそも緯度経度情報が更新時は無い（shop APIとマージする？）
      // if (!this.newEntry) {
      //   this.initLocation = {
      //     lat: this.forms.mapLatitude,
      //     lng: this.forms.mapLongitude
      //   }
      // }
      this.mapMove(value.latlng)
    }
  }
}
</script>

<style lang="sass" scoped>
.tos-box
  overflow-y: scroll
  width: 100%
  height: 600px
  max-height: calc(100vh - 200px)
  border: solid 1px #888888
  background-color: #ffffff

.none-shadow
  box-shadow: none

.map-col
  position: relative
  left: 0
  top:0

  &-map
    height: 70vh
    max-height: 500px

  &-center-pin
    pointer-events: none
    position: absolute
    top: calc(50% - 42px)
    left: calc(50% - 21px)
    z-index: 999
</style>
